// src/store/modules/account.js

import axios from "@/axios";
import endpoints from "@/endpoints.js";
const state = {
    account: null,
};

const mutations = {
    setAccount(state, accountData) {
        state.account = accountData;
    },
};

const actions = {
    async fetchAccount({ commit }) {
        try {
            // Make an API request to fetch account data
            const response = await axios.get(endpoints.account); // Replace '/account' with your actual API endpoint
            const accountData = response.data;

            
            // Commit the account data to the state
            commit("setAccount", accountData);
        } catch (error) {
            console.error("Error fetching account:", error);
            // Optionally handle error cases here
        }
    },
};

const getters = {
    account: (state) => state.account,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
